<template>
  <div>
    <Input
      @on-focus="check_unfold"
      :show_title="show_title"
      v-model="value"
      :placeholder="'请输入' + show_title"
    ></Input>

    <Drawer
      v-if="!show_multiple"
      :title="popout_title"
      width="50vw"
      :closable="false"
      v-model="popout_show"
      @on-close="emit_check"
    >
      <table class="table">
        <tbody>
          <tr v-for="(items, index) in popout_data" :key="index">
            <td v-for="(item, inde) in items" :key="inde">
              <Button
                @click="
                  show_children = true;
                  check_title = item.v;
                  children_data = item.children;
                "
                type="text"
                >{{ item.v }}</Button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </Drawer>
    <Drawer
      v-if="!show_multiple"
      :title="check_title"
      width="40vw"
      :closable="false"
      v-model="show_children"
    >
      <table class="table">
        <tbody>
          <tr v-for="(items, index) in children_data" :key="index">
            <td v-for="(item, inde) in items" :key="inde">
              <Button type="text" @click="emit_check(item.v, show_title)">{{
                item.v
              }}</Button>
            </td>
          </tr>
        </tbody>
      </table>
    </Drawer>

    <!-- 多选 START-->
    <Drawer
      v-if="show_multiple"
      :title="popout_title"
      width="50vw"
      :closable="false"
      v-model="popout_show"
      @on-close="emit_check"
    >
      <CheckboxGroup
        v-model="single"
        style="overflow-y:scroll;height: calc(100% - 151px);"
      >
        <table class="table">
          <tbody>
            <tr v-for="(items, index) in popout_data" :key="index">
              <td v-for="(item, inde) in items" :key="inde">
                <Checkbox :label="item.v">
                  {{ item.v }}
                </Checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </CheckboxGroup>

      <div style="height:100px; border-top:1px solid #ccc;">
        <!-- <div v-for="(item,index) in single" :key="index">
          {{item}}
        </div> -->
        <Tag v-for="(item,index) in single" :key="index" 
        color="success" style="margin:15px 14px 0px 0px">{{item}}</Tag>
      </div>

      <div class="drawer-footer">
        <Button style="margin-right: 8px" @click="popout_show = false"
          >取消</Button
        >
        <Button type="primary" @click="popout_show = false;emit_check(single, show_title)">确定</Button>
      </div>
    </Drawer>
    <Drawer
      v-if="show_multiple"
      :title="check_title"
      width="40vw"
      :closable="false"
      v-model="show_children"
    >
      <table class="table">
        <tbody>
          <tr v-for="(items, index) in children_data" :key="index">
            <td v-for="(item, inde) in items" :key="inde">
              <Button type="text" @click="emit_check(item.v, show_title)">{{
                item.v
              }}</Button>
            </td>
          </tr>
        </tbody>
      </table>
    </Drawer>
    <!-- 多选 END-->
  </div>
</template>
<script>
import popout from './select2v.js';
export default popout;
</script>
<style lang="less" scoped>
.table {
  width: 100%;
  text-align: center;
  border: 1px solid #dee2e6;
  border-collapse: collapse;
  td,
  th {
    padding: 2% 0;
    border: 1px solid #dee2e6;
  }
}
.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
